import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Mic } from "lucide-react";
import { Button } from "@heroui/button";
import { Tabs, Tab } from "@heroui/tabs";
import DefaultLayout from "@/layouts/default";
import TodaysMeetsComp from "@/components/meets/todays-meets-comp";
import UpComingMeetsComp from "@/components/meets/up-coming-meets-comp";
import PastMeetsComp from "@/components/meets/past-meets-comp";
import TabsComp from "@/components/tabs-comp";
import CreateQuickMeetsDrawer from "@/components/drawers/create-quick-meets-drawer";

const MeetingsPage = () => {
const { tab_id } = useParams();
const navigate = useNavigate();
const [tab, setTab] = useState("today");
const [showQuickCreate, setShowQuickCreate] = useState(false)

const tabs = [
  { key: "today", title: "Today" },
  { key: "upcoming", title: "Upcoming" },
  { key: "past", title: "Past" }
]

useEffect(() => {
  if (tab_id && ["today", "upcoming", "past"].includes(tab_id)) {
    setTab(tab_id);
  }
}, [tab_id]);

const handleTabChange = (key) => {
  const tabKey = String(key);
  setTab(tabKey);
  navigate(`/${tabKey}`, { replace: false });
};

return (
  <DefaultLayout>
    <div className="relative px-2"> 
      <div className={`${tab === "today" ? "block" : "hidden"}`}>
        <TodaysMeetsComp />
      </div>

      <div className={`${tab === "upcoming" ? "block" : "hidden"}`}>
        <UpComingMeetsComp />
      </div>

      <div className={`${tab === "past" ? "block" : "hidden"}`}>
        <PastMeetsComp />
      </div>

      <div className="fixed left-1/2 -translate-x-1/2 bottom-[100px] z-[50] w-full ps-4 pe-4 pointer-events-none">
        <div className="flex justify-between ps-4 pe-4 pointer-events-auto">
          <div>
            <TabsComp items={tabs} selectedKey={tab} defaultKey="today" onChange={handleTabChange}/>
          </div>

          <div>
              <Button onPress={() => {setShowQuickCreate(true)}} color="primary" variant="shadow" aria-label="Log out" size="md" radius="full" isIconOnly >
                <Mic className="h-4 w-4"/>
              </Button>
          </div>
        </div>
      </div>
    </div>
    <CreateQuickMeetsDrawer _show={showQuickCreate} _setShow={setShowQuickCreate}/>
  </DefaultLayout>
);
};

export default MeetingsPage;